import script from "./StageHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StageHeader.vue?vue&type=script&setup=true&lang=js"

import "./StageHeader.vue?vue&type=style&index=0&id=35f4b60b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f4b60b"]])

export default __exports__